import { ApiEntity } from "../../Api/api.model";
import { type, string, number } from "superstruct";
import { validateStruct } from "../../../utils/validate";

const LevelStruct = type({
  id: string(),
  name: string(),
  title: string(),
  description: string(),
  zenPoints: number(),
  darePoints: number(),
});

export interface Level {
  id: string,
  name: string,
  title: string,
  description: string,
  zenPoints: number,
  darePoints: number,
}

export class LevelEntity extends ApiEntity<Array<Level>> {
  constructor() {
    super('levels');
  }
  validate(rawData: Array<any>): Array<Level> {
    return rawData.map((rawItem) => validateStruct<Level>(rawItem, LevelStruct, this.endPoint,
      [{ field: 'id', transform: (id: number) => id.toString() }]));
  }
}
